import React, { FC, useEffect, useState } from 'react';
import * as S from './styled';
import { appStore } from '@store';

export const Price: FC = props => {
	const { paymentStore, VervAPI } = appStore;
	const { product } = paymentStore;
	const [pricePerWeek, setPricePerWeek] = useState<string>('6.60');

	const months = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'Jul',
		'Aug',
		'Sep',
		'Oct',
		'Nov',
		'Dec',
	];

	function addDay(n: number) {
		const dt = new Date();
		dt.setDate(dt.getDate() + n);
		const mont = dt.getMonth();
		const day = dt.getDate();
		const year = dt.getFullYear();
		let hours: string | number = dt.getHours();
		const min = dt.getMinutes();
		if (hours > 12) {
			hours = hours - 2;
			hours = `${hours.toString().slice(1)}:${min} PM`;
		} else {
			hours = `${hours}:${min} AM`;
		}
		const strDt = `${months[mont]} ${day}, ${year}, ${hours}`;
		return strDt;
	}

	useEffect(() => {
		const productData = Object.assign({}, product.details);
		let price;
		if (productData?.duration?.value) {
			price = (productData.amount / 12).toFixed(2);
			setPricePerWeek(price);
		}
	}, [product]);

	return (
		<S.PriceWrapper>
			<S.PriceTitle>Price Today</S.PriceTitle>
			<S.TrialPrice>
				<p>7-day trial*</p>
				<p>
					<span>$19.88</span> ${product.details?.intro_total}
				</p>
			</S.TrialPrice>
			<S.TrialInfo>
				You&apos;ll have 7 days to see how Verv uses its science-backed, innovative approach to
				create lasting results
			</S.TrialInfo>
			<S.PriceAfterTitle>Price After trial</S.PriceAfterTitle>
			<S.AfterInfo>
				<p>12-week plan</p>
				<p>
					${product.details?.amount}*<br />
					<span>just ${pricePerWeek}/week</span>
				</p>
			</S.AfterInfo>
			<S.Disclaimer>
				* Billed on {addDay(7)} unless cancelled before your renewal date.
			</S.Disclaimer>
		</S.PriceWrapper>
	);
};
